import { SelectableFilterOption }
  from '@/components/common/TableGrid/CustomComponents/AgGridSelectableFilter/AgGridSelectableFilter';
import { ContractLineBillingCycleOutput, VariableContractLineOutput } from '@/graphql/contracts/_generated_/contracts';

export class ContractLineFilterComparators {
  static statusComparator(contractLine: ContractLine, selectedOptions: SelectableFilterOption[]) {
    const status = contractLine.status.status;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === status);
    return Boolean(appropriateOption);
  }

  static statusVariableComparator(contractLine: VariableContractLineOutput, selectedOptions: SelectableFilterOption[]) {
    const status = contractLine.status;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === status);
    return Boolean(appropriateOption);
  }

  static billingIntervalComparator(contractLine: ContractLine, selectedOptions: SelectableFilterOption[]) {
    const interval = contractLine.billingInterval?.billingInterval;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === interval);
    return Boolean(appropriateOption);
  }

  static billingIntervalVariableComparator(contractLine: VariableContractLineOutput,
    selectedOptions: SelectableFilterOption[]) {
    const interval = contractLine.billingInterval;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === interval);
    return Boolean(appropriateOption);
  }

  static stockCodeComparator(contractLine: ContractLine, selectedOptions: SelectableFilterOption[]) {
    const interval = contractLine.product?.stockCode;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === interval);
    return Boolean(appropriateOption);
  }

  static stockNameComparator(contractLine: ContractLine, selectedOptions: SelectableFilterOption[]) {
    const interval = contractLine.product?.stockName;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === interval);
    return Boolean(appropriateOption);
  }

  static billintTypeComparator(contractLine: ContractLine, selectedOptions: SelectableFilterOption[]) {
    const type = contractLine.billingType.type;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === type);
    return Boolean(appropriateOption);
  }

  static unitPriceFrequencyComparator(contractLine: ContractLine, selectedOptions: SelectableFilterOption[]) {
    const frequency = contractLine.unitPriceFrequency?.frequency;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === frequency);
    return Boolean(appropriateOption);
  }

  static pauseStatusVariableComparator(
    contractLine: VariableContractLineOutput, selectedOptions: SelectableFilterOption[]) {
    const status = contractLine.lineBillingStatus;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === status);
    return Boolean(appropriateOption);
  }
}

export class ContractLineBCFilterComparators {
  static statusComparator(contractLine: ContractLineBillingCycleOutput, selectedOptions: SelectableFilterOption[]) {
    const status = contractLine.status;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === status);
    return Boolean(appropriateOption);
  }

  // eslint-disable-next-line max-len
  static billingIntervalComparator(contractLine: ContractLineBillingCycleOutput, selectedOptions: SelectableFilterOption[]) {
    const interval = contractLine.billingInterval;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === interval);
    return Boolean(appropriateOption);
  }

  static stockCodeComparator(
    contractLine: ContractLineBillingCycleOutput, selectedOptions: SelectableFilterOption[]) {
    const interval = contractLine.stockCode;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === interval);
    return Boolean(appropriateOption);
  }

  static stockNameComparator(
    contractLine: ContractLineBillingCycleOutput, selectedOptions: SelectableFilterOption[]) {
    const interval = contractLine.stockName;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === interval);
    return Boolean(appropriateOption);
  }

  static billintTypeComparator(
    contractLine: ContractLineBillingCycleOutput, selectedOptions: SelectableFilterOption[]) {
    const type = contractLine.billingType;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === type || el.text === type);
    return Boolean(appropriateOption);
  }

  static unitPriceFrequencyComparator(
    contractLine: ContractLineBillingCycleOutput, selectedOptions: SelectableFilterOption[]) {
    const frequency = contractLine.unitPriceFrequency;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === frequency);
    return Boolean(appropriateOption);
  }

  static pauseStatusComparator(
    contractLine: ContractLineBillingCycleOutput, selectedOptions: SelectableFilterOption[]) {
    const status = contractLine.lineBillingStatus;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === status);
    return Boolean(appropriateOption);
  }
}

export class VariableContractLineFilterComparators {
  static statusComparator(contractLine: VariableContractLineOutput, selectedOptions: SelectableFilterOption[]) {
    const status = contractLine.status;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === status);
    return Boolean(appropriateOption);
  }

  static pauseStatusComparator(contractLine: VariableContractLineOutput, selectedOptions: SelectableFilterOption[]) {
    const status = contractLine.lineBillingStatus;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === status);
    return Boolean(appropriateOption);
  }

  static billingIntervalComparator(contractLine: ContractLine, selectedOptions: SelectableFilterOption[]) {
    const interval = contractLine.billingInterval?.billingInterval;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === interval);
    return Boolean(appropriateOption);
  }

  static stockCodeComparator(contractLine: ContractLine, selectedOptions: SelectableFilterOption[]) {
    const interval = contractLine.product?.stockCode;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === interval);
    return Boolean(appropriateOption);
  }

  static stockNameComparator(contractLine: ContractLine, selectedOptions: SelectableFilterOption[]) {
    const interval = contractLine.product?.stockName;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === interval);
    return Boolean(appropriateOption);
  }

  static billintTypeComparator(contractLine: ContractLine, selectedOptions: SelectableFilterOption[]) {
    const type = contractLine.billingType.type;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === type);
    return Boolean(appropriateOption);
  }

  static unitPriceFrequencyComparator(contractLine: ContractLine, selectedOptions: SelectableFilterOption[]) {
    const frequency = contractLine.unitPriceFrequency?.frequency;
    const appropriateOption = selectedOptions.find((el) => el.returnValue === frequency);
    return Boolean(appropriateOption);
  }
}
